import { render, staticRenderFns } from "./commonWrap.vue?vue&type=template&id=4efa53cb&scoped=true"
import script from "./commonWrap.vue?vue&type=script&lang=js"
export * from "./commonWrap.vue?vue&type=script&lang=js"
import style0 from "./commonWrap.vue?vue&type=style&index=0&id=4efa53cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efa53cb",
  null
  
)

export default component.exports